<script>
import Ascii from '../components/Utils/Ascii'
export default {
  name: 'Loading',
  components: { Ascii }
}

</script>

<template>
  <main 
    lang="en"
    id="app"
  >
    <Ascii /> 
    <p class="message"> Loading... </p>
  </main>
</template>

<style scoped>

:root {
  --background: rgb(3, 29, 11);
  --copy: rgb(231, 231, 231);
}

html,
body,
#app {
  margin: 0; padding: 0;
  height: 100%; width: 100%;
  font-family: monospace;
  color: var(--copy);
  background: var(--background);
}

#app {
  position: relative;
  display: flex;
}

.message {
  margin: auto;
}

</style>
